import React from 'react'
import dayjs from 'dayjs'
import get from 'lodash/get'

export default({row, name}) => {
    const value = get(row, name, '')

    if(!value) {
        return null
    }

    return <div>{dayjs(value).format("L")}</div>
}